import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { GetTasksRes, TaskDto } from '@dealstack/shared/lib/generated';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';

export const getExportLists = async (endpoint: string, args: TaskDto, signal?: AbortSignal) => {
	const { sortBy, pagination } = args;
	return await makeRequest<ApiV1.Response<GetTasksRes>>(
		{
			endpoint,
			method: HTTP_METHOD.POST,
			body: JSON.stringify({
				sortBy,
				pagination,
			}),
		},
		{ abortSignal: signal }
	);
};

export const downloadExportDocument = async (
	endpoint: string,
	args: { s3Key: string; fileName?: string },
	signal?: AbortSignal
) => {
	const { s3Key, fileName } = args;

	let formattedEndpoint = formatUnicorn(endpoint, { s3Key: encodeURIComponent(s3Key) });

	if (fileName) {
		formattedEndpoint += `?fileName=${encodeURIComponent(fileName)}`;
	}

	return await makeRequest<{ payload: { downloadUrl: string } }>(
		{
			endpoint: formattedEndpoint,
			method: HTTP_METHOD.GET,
		},
		{ abortSignal: signal }
	);
};
